import { render, staticRenderFns } from "./BoFinance.vue?vue&type=template&id=9157ccba&scoped=true&"
import script from "./BoFinance.vue?vue&type=script&lang=js&"
export * from "./BoFinance.vue?vue&type=script&lang=js&"
import style0 from "./BoFinance.vue?vue&type=style&index=0&id=9157ccba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9157ccba",
  null
  
)

export default component.exports